import { DataTable as AntdDataTable } from "@empglabs/backoffice-ui-kit"

const DataTable = props => {
  return <AntdDataTable {...props} />
}
export default DataTable
